import React, { Component } from 'react';
import moment from "moment";
import PhoneInput, { parsePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import Request from "../../core/httpClient";
const request = new Request();

class PropietarioEditarModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			idPersona: 0,
			pNombre: '',
			IDireccion: '',
			IMunicipio: '',
			IEstado: '',
			ICp: '',
			pTelefono: '',
			IPais: '',
			IGenero: 0,
			IId: '',
			INumId: '',
			IVigencia: '',
			IFechaIngreso: '',
			code: '',
			Iviv: '',
			IIdViv: 0,
			email: '',
			pFechaVenta: '',
			citye: '',
			comentarios: '',
			es_residente: ''
		}

	}


	componentDidUpdate(prevProps, prevState) {
		if (this.state !== prevState) {
			this.props.setInfo(this.state);
		}
		if (this.props.telefonoError !== prevProps.telefonoError) {
			this.setState({ telefonoError: this.props.telefonoError });
		}

		if (this.props.propietario !== prevProps.propietario) {
			let phone = '';
			const { telefono } = this.props.propietario;
			if (telefono) {
				phone = parsePhoneNumber(`+${telefono}`);
				if (phone) {
					phone = phone.number;
				}
			}
			this.setState({
				pIdPersona: this.props.propietario.id_persona,
				pNombre: this.props.propietario.nombre,
				pDireccion: this.props.propietario.direccion,
				pMunicipio: this.props.propietario.municipio,
				pEstado: this.props.propietario.estado,
				pCp: this.props.propietario.cp,
				pTelefono: phone,
				pPais: this.props.propietario.pais,
				pGenero: this.props.propietario.genero,
				pId: this.props.propietario.tipo_identificacion,
				pNumId: this.props.propietario.num_identificacion,
				pVigencia: this.props.propietario.vigencia_identificacion,
				pFechaCompra: moment(this.props.propietario.fecha_compra).format("YYYY-MM-DD"),
				pFechaVenta: moment(this.props.propietario.fecha_venta).format("YYYY-MM-DD"),
				code: this.props.propietario.code,
				Iviv: this.props.propietario.numero_registro,
				pIdViv: this.props.propietario.id_vivienda,
				email: this.props.propietario.email,
				citye: this.props.propietario.ciudad || '',
				comentarios: this.props.propietario.comentarios || '',
				es_residente: this.props.propietario.es_residente || ''
			});
			//console.log(this.props.propietario);
			// this.refs['input' + this.props.line ].focus();
		}
	}


	render() {
		return (
			<div className="full row align-center">
				<div className="column full">
					<div className="flex flex-col space-y-2 w-full">
						{/* Subfraccionamiento */}
						<div className="flex items-center gap-2">
							<label className="w-32 text-sm font-semibold">{this.props.subLabel}:</label>
							<input
								type="text"
								name="subfraccionamiento"
								disabled
								value={this.props.subname}
								className="flex-1 border rounded px-2 py-1 text-sm"
								placeholder="Subfraccionamiento"
							/>
						</div>

						{/* Unidad */}
						<div className="flex items-center gap-2">
							<label className="w-32 text-sm font-semibold">Unidad:</label>
							<input
								type="text"
								name="vivienda"
								disabled
								value={this.state.pRegistro}
								onChange={e => this.setState(prev => ({ ...prev, pRegistro: e.target.value }))}
								className="flex-1 border rounded px-2 py-1 text-sm"
								placeholder="N° de vivienda"
								required
								maxLength="64"
							/>
						</div>

						{/* Teléfono */}
						<div className="flex items-center gap-2">
							<label className="w-32 text-sm font-semibold">
								Teléfono:<span className="text-red-500">*</span>
							</label>
							<PhoneInput
								displayInitialValueAsLocalNumber
								name="phoneNumber"
								defaultCountry="MX"
								maxLength="18"
								placeholder="Número de teléfono"
								value={this.state.pTelefono}
								disabled
								onChange={value =>
									this.setState(prev => ({ ...prev, pTelefono: value, telefonoError: undefined }))
								}
								error={this.state.telefonoError}
								readOnly
								className="flex-1 border rounded px-2 py-1 text-sm"
							/>
						</div>

						{/* Nombre completo */}
						<div className="flex items-center gap-2">
							<label className="w-32 text-sm font-semibold">
								Nombre completo:<span className="text-red-500">*</span>
							</label>
							<input
								type="text"
								name="fullName"
								value={this.state.pNombre}
								id="editownername"
								onChange={e => this.setState(prev => ({ ...prev, pNombre: e.target.value }))}
								className="flex-1 border rounded px-2 py-1 text-sm"
								placeholder="Nombre completo del propietario"
								required
								maxLength="64"
								disabled
							/>
						</div>

						<div className="flex flex-col space-y-2 w-full">
							{/* Género y Correo */}
							<div className="grid grid-cols-2 gap-2">
								<div className="flex flex-col space-y-1">
									<label className="text-sm font-semibold">Género:</label>
									<select
										name="sex"
										value={this.state.pGenero}
										onChange={e => this.setState(prev => ({ ...prev, pGenero: e.target.value }))}
										className="border rounded px-2 py-1 text-sm input-edit-select-sm text-left"
										required
									>
										<option value="0">Hombre</option>
										<option value="1">Mujer</option>
										<option value="2">No especificado</option>
									</select>
								</div>
								<div className="flex flex-col space-y-1">
									<label className="text-sm font-semibold">Correo:</label>
									<input
										type="email"
										name="email"
										value={this.state.email}
										onChange={e => this.setState(prev => ({ ...prev, email: e.target.value }))}
										className="border rounded px-2 py-1 text-sm input-edit-select-sm text-left"
										placeholder="Email"
										maxLength="64"
									/>
								</div>
							</div>

							{/* Identificación e ID */}
							<div className="grid grid-cols-2 gap-2">
								<div className="flex flex-col space-y-1">
									<label className="text-sm font-semibold">Identificación:</label>
									<select
										name="id"
										id="idEddit"
										value={this.state.pId}
										onChange={e => this.setState(prev => ({ ...prev, pId: e.target.value }))}
										className="border rounded px-2 py-1 text-sm input-edit-select-sm text-left"
									>
										<option value="0">INE</option>
										<option value="1">Pasaporte/Visa</option>
										<option value="2">Curp</option>
										<option value="3">Cartilla Militar</option>
									</select>
								</div>
								<div className="flex flex-col space-y-1">
									<label className="text-sm font-semibold">ID:</label>
									<input
										type="text"
										name="numIdEddit"
										value={this.state.pNumId}
										onChange={e => this.setState(prev => ({ ...prev, pNumId: e.target.value }))}
										className="border rounded px-2 py-1 text-s input-edit-select-sm text-left"
										placeholder="Número ID"
										maxLength="24"
									/>
								</div>
							</div>

							{/* Dirección */}
							<div className="flex flex-col space-y-1">
								<label className="text-sm font-semibold">Dirección:</label>
								<input
									type="text"
									name="address"
									value={this.state.pDireccion}
									onChange={e => this.setState(prev => ({ ...prev, pDireccion: e.target.value }))}
									className="border rounded px-2 py-1 text-sm input-edit-select-sm text-left"
									placeholder="Dirección de contacto"
									maxLength="150"
								/>
							</div>
						</div>

					</div>








					<div className="flex flex-col space-y-2 w-full">
						{/* Municipio y Ciudad */}
						<div className="grid grid-cols-2 gap-2">
							<div className="flex flex-col space-y-1">
								<label className="text-sm font-semibold">Municipio:</label>
								<input
									type="text"
									name="municipality"
									value={this.state.pMunicipio}
									onChange={e => this.setState(prev => ({ ...prev, pMunicipio: e.target.value }))}
									className="border rounded px-2 py-1 text-sm text-sm input-edit-select-sm text-left"
									placeholder="Municipio"
									maxLength="80"
								/>
							</div>
							<div className="flex flex-col space-y-1">
								<label className="text-sm font-semibold">Ciudad:</label>
								<input
									type="text"
									value={this.state.citye}
									onChange={e => this.setState(prev => ({ ...prev, citye: e.target.value }))}
									className="border rounded px-2 py-1 text-sm text-sm input-edit-select-sm text-left"
									id="citye"
									placeholder="Ciudad"
								/>
							</div>
						</div>

						{/* Código Postal y Estado */}
						<div className="grid grid-cols-2 gap-2">
							<div className="flex flex-col space-y-1">
								<label className="text-sm font-semibold">C.P:</label>
								<input
									type="text"
									value={this.state.pCp}
									onChange={e => this.setState(prev => ({ ...prev, pCp: e.target.value }))}
									name="zip"
									className="border rounded px-2 py-1 text-sm text-sm input-edit-select-sm text-left"
									placeholder="Código postal"
									maxLength="10"
								/>
							</div>
							<div className="flex flex-col space-y-1">
								<label className="text-sm font-semibold">Estado:</label>
								<input
									type="text"
									name="state"
									value={this.state.pEstado}
									onChange={e => this.setState(prev => ({ ...prev, pEstado: e.target.value }))}
									className="border rounded px-2 py-1 text-sm text-sm input-edit-select-sm text-left"
									placeholder="Estado"
									maxLength="24"
								/>
							</div>
						</div>

						{/* País */}
						<div className="flex flex-col space-y-1">
							<label className="text-sm font-semibold">País:</label>
							<input
								type="text"
								value={this.state.pPais}
								onChange={e => this.setState(prev => ({ ...prev, pPais: e.target.value }))}
								name="country"
								className="border rounded px-2 py-1 text-sm text-sm input-edit-select-sm text-left"
								placeholder="País"
								maxLength="10"
							/>
						</div>
					</div>







					<div className="flex flex-col space-y-2 w-full">
						{/* Fechas */}
						<div className="grid grid-cols-2 gap-2">
							<div className="flex flex-col space-y-1">
								<label className="text-sm font-semibold">
									Fecha de compra:<span className="text-red-500">*</span>
								</label>
								<input
									type="date"
									value={this.state.pFechaCompra}
									onChange={e => this.setState(prev => ({ ...prev, pFechaCompra: e.target.value }))}
									required
									className="border rounded px-2 py-1 text-sm input-edit-select-sm text-left"
									id="fcompra"
								/>
							</div>
							<div className="flex flex-col space-y-1">
								<label className="text-sm font-semibold">Fecha de venta:</label>
								<input
									type="date"
									value={this.state.pFechaVenta}
									onChange={e => this.setState(prev => ({ ...prev, pFechaVenta: e.target.value }))}
									className="border rounded px-2 py-1 text-sm input-edit-select-sm text-left"
									id="fventaedit"
								/>
							</div>
						</div>

						{/* Comentarios */}
						<div className="flex flex-col space-y-1">
							<label className="text-sm font-semibold">Comentarios:</label>
							<textarea
								name="comentarios"
								id="comentarios_inquilinos"
								value={this.state.comentarios}
								onChange={e => this.setState(prev => ({ ...prev, comentarios: e.target.value }))}
								className="border rounded px-2 py-1 text-sm w-full input-edit-select-sm text-left"
								rows="3"
								maxLength="500"
							/>
						</div>

						{/* Es residente */}
						<div className="flex items-center gap-2">
							<input
								type="checkbox"
								name="esInquilino"
								id="esInquilino"
								disabled
								checked={this.state.es_residente ? true : false}
								className="h-4 w-4"
							/>
							<span className="text-sm font-semibold">Es residente</span>
						</div>

						{/* Nota de campos obligatorios */}
						<div className="flex items-center">
							<p className="text-xs text-gray-600">
								<span className="text-red-500">*</span> Indica un campo obligatorio
							</p>
						</div>
					</div>


				</div>
			</div>
		);
	}

	handleClose() {
		this.setState({
			showModal: false,
		});
	}
}

export default PropietarioEditarModal;